module.exports = __webpack_public_path__ + "catalog/items/dining/round-dining-table-for-6/round-dining-table-for-6.svg";